// frontend/src/shared/theme/typography.js

const typography = {
  fontFamily: "'Nunito', sans-serif",

  weight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  size: {
    xs: "12px",
    sm: "14px",
    base: "16px",
    lg: "18px",
    xl: "20px",
    "2xl": "24px",
  },

  lineHeight: {
    tight: "16px",
    sm: "20px",
    base: "22px",
    md: "24px",
    lg: "28px",
    xl: "32px",
  },

  tracking: {
    tight: "-0.02em",
    normal: "0",
    wide: "0.08em",
    wider: "0.12em",
  },
};

export default typography;